<template>
    <ion-row data-cy="default-toppings" v-if="defaultToppings">
        <checklist :items="defaultToppings" :hideSplitOpts="hideSplitOpts" class="px-m8" />
    </ion-row>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import baseToppings, { passThroughBindings } from '@/components/menu/toppings/baseToppings.vue';

export default defineComponent({
    extends: baseToppings,
    props: { hideSplitOpts: Boolean },
    setup(props, { emit }) {
        const { localDefaultToppings } = passThroughBindings(props, emit);

        return { localDefaultToppings };
    },
});
</script>
